export default "__VITE_ASSET__DTa3r2Ua__"